import React, { useState } from "react";
import CheckMarkSvg from "../../Icons/CheckMarkSvg";
import { ButtonBase } from "@reusejs/react";

export default function ConsultationComponent() {
  const consultation = [
    { label: "Document Analysis" },
    { label: "Technical/Physical Verification" },
    { label: "Document Writing" },
    { label: "Price Analysis" },
  ];
  return (
    <div className="py-16 bg-white overflow-hidden">
      <div className="relative max-w-xl mx-auto px-4 sm:px-4 lg:px-6 lg:max-w-7xl">
        <div className="relative lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="relative pr-8">
            <h3 className="text-4xl font-extrabold tracking-tight sm:text-3xl">
              Expert Consultation
            </h3>
            <p className="mt-3 text-lg text-gray-500">
              We will be one point of contact for all the interested investors
              in auction properties starting from EMD payment till Registration
              of the property.
            </p>

            <div className="mt-8">
              {consultation.map((item, index) => {
                return (
                  <div className="flex items-center gap-3 py-3" key={index}>
                    <CheckMarkSvg />
                    <div>{item.label}</div>
                  </div>
                );
              })}
            </div>
            <div className="mt-4">
              <ButtonBase
                variant="primary"
                type="submit"
                label="Request servies"
                onClick={() => {
                  console.log("button clicked");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "px-4 py-3",
                }}
              />
            </div>
          </div>

          <div className="mt-10 px-8 h-full -mx-4 relative lg:mt-0">
            <div className="w-full h-full">
              <img
                className="object-cover rounded-t-md"
                src="/consultation.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
